import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class HouseholdClaimAdjuster extends BaseModel {
    @Expose() idadjuster = 0;
    @Expose() adjusterName = "";
    @Expose() imageUrl = "";
}
